import { isDate } from 'date-fns'
import transform from '../../utils/ResponseTransformator'
import mapResponseToRoom from './mappers/mapResponseToRoom'
import { IData } from './request/response'
import { IRoom } from '.'

const PAGE_SIZE = 500

function buildUrl(calendarId: number, page: number, modifyDate?: Date): string {
  const d = isDate(modifyDate) ? Math.floor(modifyDate.getTime() / 1000) : 0

  if (d > 0) {
    return `/api/v2/room/index/id_calendar/${calendarId}/modify_date/${d}/page_size/${PAGE_SIZE}/page/${page}`
  }

  return `/api/v2/room/index/id_calendar/${calendarId}/page_size/${PAGE_SIZE}/page/${page}`
}

async function fetchOnePage(
  api: GlobalFetch,
  calendarId: number,
  page: number,
  modifyDate?: Date,
): Promise<{ rooms: IRoom[]; totalPages: number }> {
  const response = await api.fetch(buildUrl(calendarId, page, modifyDate))
  let text = await response.text()
  text = transform(text)
  const data: IData = JSON.parse(text)

  return {
    rooms: data.items.map(mapResponseToRoom),
    totalPages: Number(data.max_page) || 1,
  }
}

export default function(api: GlobalFetch) {
  return async function(
    calendarId: number,
    modifyDate?: Date,
  ): Promise<IRoom[]> {
    if (calendarId == null || Number.isNaN(Number(calendarId))) {
      throw new Error('Missing calendar id for room list')
    }

    const page1 = await fetchOnePage(api, calendarId, 1, modifyDate)
    const allRooms = [...page1.rooms]

    if (page1.totalPages > 1) {
      const pageNumbers = []
      for (let i = 2; i <= page1.totalPages; i++) {
        pageNumbers.push(i)
      }

      const otherPages = await Promise.all(
        pageNumbers.map(page =>
          fetchOnePage(api, calendarId, page, modifyDate),
        ),
      )

      for (const page of otherPages) {
        allRooms.push(...page.rooms)
      }
    }

    return allRooms
  }
}
